// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request (state) {
    state.authStatus = 'loading'
  },
  auth_success (state, { token, expires_in, user, permissions }) {
    state.authStatus = 'success'
    state.token = token
    state.expires_in = expires_in
    state.user = user
    state.permissions = permissions
  },
  auth_error (state) {
    state.authStatus = 'error'
    state.token = ''
    state.expires_in = 0
    state.user = {}
    state.permissions = []
  },
  logout (state) {
    state.authStatus = ''
    state.token = ''
    state.expires_in = 0
    state.user = {}
    state.permissions = []
  },
  setPermissions (state, {permissions}) {
    state.permissions = permissions
  },

  setTableList (state, tableList) {
    state.tableList = tableList
  },
  setNotification (state, notifList) {
    state.notification = notifList
  }
}
